mutation UpdateEmployee($employeeInput: EmployeeChangeInput!) {
  updateEmployee(input: { employeeInput: $employeeInput }) {
    employee {
      id
    }
  }
}
